import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Headers, Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { AppConstants } from '../core/app.constants';
import { BaseResponse, GruppiLDAPResponse, NewUser, User, UserData, UserDataResponse, UserInfo, UsersResponse, UserStatisticsProspectResponse } from "../core/core.component";

@Injectable()
export class UserService {

    constructor(private http: Http, private datePipe: DatePipe) { }

    getUsers(srmToken, onlyActive?: boolean, detailed?: boolean): Observable<UsersResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        if (onlyActive != null && typeof (onlyActive) != 'undefined') {
            params.append("includeInactive", !onlyActive + "");
        }
        if (detailed == null || typeof (detailed) == 'undefined') {
            params.append("detailed", "false");
        } else {
            params.append("detailed", detailed + "");
        }
        return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
    }

    isUserAdmin(srmToken): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/iscurrentadmin";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
    }

    currentUserInfo(srmToken): Observable<UserInfo> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/currentUserInfo";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
    }

    findDomainUser(srmToken, username: string): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/domainUser/" + username;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
    }

    insertUser(srmToken, user: User): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/insert";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = {
            username: user.username,
            deviceId: user.deviceId,
            startDate: this.datePipe.transform(user.startDate, "yyyy-MM-dd"),
            endDate: this.datePipe.transform(user.endDate, "yyyy-MM-dd"),
            typeUser: user.typeUser,
            ipAllowed: user.ipAllowed,
            codiceFiscale: user.codiceFiscale,
            notes: user.notes,
            loginLDAPUtente: user.loginLDAPUtente,
            pdw: user.pdw
        };
        return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
    }


    insertNewUser(srmToken, user: NewUser): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/insertNew";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = {
            username: user.username,
            deviceId: user.deviceId,
            startDate: this.datePipe.transform(user.startDate, "yyyy-MM-dd"),
            endDate: this.datePipe.transform(user.endDate, "yyyy-MM-dd"),
            typeUser: user.typeUser,
            ipAllowed: user.ipAllowed,
            codiceFiscale: user.codiceFiscale,
            notes: user.notes,
            nome: user.nome,
            cognome: user.cognome,
            gruppi: user.gruppi,
            loginLDAPUtente: user.loginLDAPUtente,
            pdw: user.pdw

        };
        return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    updateUser(srmToken, user: User): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/" + user.id + "/update";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = {
            deviceId: user.deviceId,
            startDate: this.datePipe.transform(user.startDate, "yyyy-MM-dd"),
            endDate: this.datePipe.transform(user.endDate, "yyyy-MM-dd"),
            typeUser: user.typeUser,
            ipAllowed: user.ipAllowed,
            codiceFiscale: user.codiceFiscale,
            notes: user.notes,
            username: user.username,
            loginLDAPUtente: user.loginLDAPUtente,
            pdw: user.pdw

        };
        return this.http.put(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    getUserProspects(srmToken, month: number, year: number): Observable<UserStatisticsProspectResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/stats/" + month + "/" + year;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
    }


    getGruppiLDAP(srmToken): Observable<GruppiLDAPResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/userData/gruppiLDAP";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
    }



    downloadUserProspects(srmToken, month: number, year: number): Observable<any> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/stats/" + month + "/" + year;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        params.append("download", "true");
        return this.http.get(url, { search: params, headers: headers, responseType: ResponseContentType.Blob }).map(res => res.blob());
    }

    getUserData(srmToken, userId: number): Observable<UserDataResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/userData/" + userId;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
    }

    updateUserData(srmToken, userId: number, userData: UserData): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/users/userData/" + userId + "/update";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.put(url, userData, { headers: headers }).map((responseData) => responseData.json());
    }

    private userDataComponentStatus = new Subject<User>();

    getUserDataComponentStatus(): Observable<User> {
        return this.userDataComponentStatus.asObservable();
    }

    openUserDataComponent(user: User) {
        this.userDataComponentStatus.next(user);
    }

    closeUserDataComponent() {
        this.userDataComponentStatus.next();
    }
}



// WEBPACK FOOTER //
// ./src/app/service/user.service.ts